/**
 * EAKC — Two Weeks of Building a Self-Learning AI Knowledge Companion
 * 80-slide long-form explainer · captured 02 June 2026
 * Data-driven: SLIDES (./slides) drive layout components (./layouts).
 * Dark cinematic + neon house style (shared with HermesEAKC / EAKCSecurity).
 */

import { SLIDES } from "./slides";

export const FPS = 30;
export const WIDTH = 1920;
export const HEIGHT = 1080;

export const COLORS = {
  bg: "#050B18",
  bgCard: "#121D38",
  bgCardLight: "#1A2548",
  neonPink: "#FF2D95",
  neonBlue: "#00D4FF",
  neonPurple: "#A855F7",
  neonGreen: "#00FF88",
  neonOrange: "#FF6B35",
  neonYellow: "#FFD60A",
  neonCyan: "#00E5FF",
  neonRed: "#FF3366",
  neonLime: "#84FF57",
  neonAmber: "#FFB020",
  neonIndigo: "#7C83FF",
  textPrimary: "#FFFFFF",
  textSecondary: "#B8C5E0",
  textMuted: "#6B7DA0",
};

export const FONTS = {
  heading: "Inter, SF Pro Display, system-ui, sans-serif",
  body: "Inter, SF Pro Text, system-ui, sans-serif",
  mono: "JetBrains Mono, SF Mono, Fira Code, monospace",
};

export const SPRING = {
  snappy: { damping: 200, mass: 0.5 },
  bouncy: { damping: 100, mass: 0.5 },
  gentle: { damping: 150, mass: 0.8 },
  slow: { damping: 120, mass: 1.2 },
  punch: { damping: 80, mass: 0.4 },
};

export const TOTAL_SLIDES = SLIDES.length;

/** Slide numbers that open a section — rendered as a full-bleed divider. */
export const SECTION_NS = new Set<number>([7, 15, 23, 39, 49, 57, 69, 74]);

/** Accent color per slide number (one hue per concept arc). */
export function accentFor(n: number): string {
  if (n <= 6) return COLORS.neonIndigo; // cold open
  if (n <= 14) return COLORS.neonBlue; // AI needs your world (grounding/RAG)
  if (n <= 22) return COLORS.neonCyan; // from answering to doing (agents)
  if (n <= 38) return COLORS.neonPurple; // learns from experience (headliner)
  if (n <= 48) return COLORS.neonAmber; // how do you know it's right (evals)
  if (n <= 56) return COLORS.neonGreen; // giving AI tools (MCP)
  if (n <= 68) return COLORS.neonOrange; // making it real (cost/privacy/trust)
  if (n <= 73) return COLORS.neonPink; // built with AI
  if (n <= 78) return COLORS.neonBlue; // the convergence
  return COLORS.neonIndigo; // close
}

/** Cross-fade length between slides (frames). */
export const TRANSITION = 16;

/**
 * Each slide stays on screen for about as long as it takes to read its narration
 * FAST (~205 words per minute) plus a short beat to breathe. Duration is therefore
 * proportional to the script length of that specific slide — short lines are short,
 * dense slides linger — instead of being clamped to a fixed band.
 */
export const WORDS_PER_SEC = 3.4; // ~205 wpm, a brisk voiceover pace
export const READ_PAD_SEC = 0.6; // entrance/exit breath
const MIN_SEC = 3;
const MAX_SEC = 24; // safety cap only

export function slideSeconds(narration: string): number {
  const words = (narration || "").trim().split(/\s+/).filter(Boolean).length;
  const secs = words / WORDS_PER_SEC + READ_PAD_SEC;
  return Math.max(MIN_SEC, Math.min(MAX_SEC, secs));
}

/** Per-slide on-screen duration in frames = fast read time of its narration. */
export const SLIDE_DURATIONS: number[] = SLIDES.map((s) =>
  Math.round(slideSeconds(s.narration) * FPS),
);

/** Composition length = sum of sequences minus the overlapped transitions. */
export const TOTAL_DURATION =
  SLIDE_DURATIONS.reduce((a, b) => a + b, 0) -
  Math.max(0, SLIDE_DURATIONS.length - 1) * TRANSITION;

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
